import { useState } from 'react';
import { products } from '@/mocks/multifierros';
import ProductDetailModal from './ProductDetailModal';
import HorizontalScroll from '@/components/feature/HorizontalScroll';

const productImages: Record<string, string> = {
  'prod-marcos-viga': 'https://public.readdy.ai/ai/img_res/edited_20a723171fed61bff05dd733a50910f4_97fb9568.jpg',
  'prod-marcos-reticulados': 'https://public.readdy.ai/ai/img_res/edited_8a84e6fcf4437af321f50e7790afcddf_08afb339.jpg',
  'prod-splitset': 'https://public.readdy.ai/ai/img_res/edited_9b4e5f370d5bfbe6cb815ae3e6eb6bed_7322faa2.jpg',
  'prod-tuercas-placas': 'https://public.readdy.ai/ai/img_res/edited_8117c723e112b820573631182fcf5318_ea0fe19e.jpg',
  'prod-anillos-blindaje': 'https://public.readdy.ai/ai/img_res/edited_b652f720c778806750e846cad6843413_9281590c.jpg',
  'prod-estructuras-metalicas': 'https://readdy.ai/api/search-image?query=Heavy%20duty%20industrial%20steel%20staircase%20structure%20for%20underground%20mining%20tunnel%20access%2C%20dark%20gray%20metal%20stairs%20with%20safety%20handrails%20and%20non-slip%20grating%20steps%20installed%20inside%20a%20rocky%20mine%20tunnel%20entrance%20with%20rock%20walls%20and%20industrial%20lighting%2C%20rugged%20mining%20environment%20with%20conveyor%20belt%20in%20background%2C%20professional%20industrial%20photography%20sharp%20detail%20photorealistic%20dramatic%20contrast&width=700&height=500&seq=grid-estructuras-mineras&orientation=landscape&nocache=true',
};

const productTitles: Record<string, string> = {
  'prod1': 'Fabricación Marcos Viga',
  'prod2': 'Fabricación Marcos Reticulados',
  'prod3': 'FABRICACION DE SPLIT SET - PLANCHUELAS - BARRAS HELICOIDALES',
  'prod4': 'Tuercas, Placas y Acoples',
  'prod6': 'Fabricación Anillos de Blindaje',
  'prod7': 'Fabricación Estructuras Metálicas',
};

export default function ProductsGrid() {
  const [hovered, setHovered] = useState<string | null>(null);
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null);

  return (
    <section id="fabricacion" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-50 tracking-wide">
            Fabricación
          </h2>
          <p className="text-foreground-300 text-sm md:text-base max-w-2xl mx-auto mt-4 leading-relaxed">
            Multifierros fabrica productos de acero para la industria minera con una reconocida calidad.
            Estamos en la búsqueda permanente de la vanguardia tecnológica y contamos con un
            personal altamente capacitado y de vasta experiencia.
          </p>
        </div>

        {/* Horizontal scrollable carousel */}
        <HorizontalScroll gap={20}>
          {products.map((prod) => (
            <button
              key={prod.id}
              onClick={() => setSelectedProduct(prod.id)}
              className="group relative flex-shrink-0 w-[280px] md:w-[370px] h-64 md:h-72 overflow-hidden rounded-sm cursor-pointer border-0 bg-transparent p-0 text-left"
              onMouseEnter={() => setHovered(prod.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <img
                src={productImages[prod.imageSeq]}
                alt={productTitles[prod.id] || prod.title}
                className={`w-full h-full object-cover object-center transition-transform duration-700 ${hovered === prod.id ? 'scale-110' : 'scale-100'}`}
              />
              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/80 via-black/50 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl text-white tracking-wider leading-tight text-center">
                  {productTitles[prod.id] || prod.title}
                </h3>
              </div>
            </button>
          ))}
        </HorizontalScroll>
      </div>

      {/* Product Detail Modal */}
      <ProductDetailModal
        productId={selectedProduct}
        onClose={() => setSelectedProduct(null)}
      />
    </section>
  );
}